<script>
	import { onDestroy, getContext, onMount } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles'
	import { sort_order } from '../library/scripts/utils'
	import * as animateScroll from 'svelte-scrollto'
	import { getCookie } from '../library/scripts/cookie'

	import {
		storeElementID,
		storeData,
		storeShowTools,
		storeSiteManagement,
		storeBuilderPreview,
		storeContact,
		storeShowGallery,
		storeShowFoods,
		storeShowDrinks,
		storeShowRooms,
		storeShowBooking,
		storeUpdateSingle,
		storeActiveBlock,
	} from '../library/scripts/Store.svelte'
	import GalleryBlock from './GalleryBlock.svelte'
	import Gallery from '../library/LayoutStuff/CarouselGallery.svelte'
	import Slider from '../library/LayoutStuff/CarouselCover.svelte'
	import Block from '../components/Block.svelte'
	import SingleImageBlock from '../components/UpdateSingleImage.svelte'
	import Navbar from '../components/Navbar.svelte'
	import Contact from '../components/Contact.svelte'
	import GuestHouse from '../components/GuestHouse.svelte'
	import Drinks from '../components/MenuDrinks.svelte'
	import Foods from '../components/MenuFoods.svelte'
	import Booking from '../components/RestaurantBooking.svelte'
	import Shop from '../components/Shop.svelte'
	import ScrollTop from './ScrollTop.svelte'
	import Administrator from './admin/Admin.svelte'
	import CookieConsent from '../library/CookieConsent.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	const globals = getContext('globals')
	const colorError = globals.colorError
	const fsS = globals.fsS
	const inputBgFocus = globals.inputBgFocus
	const isMobi = globals.mobile
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	// redirect user to " #/" is user is not admin and tries to access #builder directly
	const userID = getCookie('id')
	if (!userID) document.location = '/#/'

	// reset storeUpdate single
	storeUpdateSingle.set(false)

	let showTools
	let showPreview

	//the scroll caret
	let caretColor
	let caretHover

	//the food menu
	let showRooms
	let offsetRooms

	//the food menu
	let showFoods
	let offsetFood

	//the drinks menu
	let showDrinks
	let offsetDrinks

	//the bookings
	let showBooking
	let offsetBooking

	//the gallery
	let showGallery
	let offsetGallery

	//contact
	let showForm
	let offsetContact

	let elementID = null
	let siteManagement = false

	let windowHeight

	$: windowHeight = window.innerHeight

	let configFile
	let showContent = true
	let bg

	const stoData = storeData.subscribe((value) => {
		if (value) {
			value.blocks = sort_order(value.blocks)
			showContent = true
			bg = value.body
			configFile = value
			caretColor = value.caretColor
			caretHover = value.caretHover
		}
	})

	const stoShowRooms = storeShowRooms.subscribe((value) => {
		showRooms = value
	})

	$: if (showRooms) {
		const roomsTO = setTimeout(() => {
			const roomContainer = document.querySelector('#rooms_container')
			if (roomContainer) {
				const clHeight = document.querySelector('#rooms_container').clientHeight
				offsetRooms = document.querySelector('#rooms_container').getBoundingClientRect()
				if (offsetRooms.top - 400 < -clHeight) {
					storeShowRooms.set(false)
					animateScroll.scrollTo({ element: '#roomstitle', duration: 500 })
				}

				if (offsetRooms.top > windowHeight + 200) {
					storeShowRooms.set(false)
				}
				clearTimeout(roomsTO)
			}
		}, 200)
	}

	const stoShowFoods = storeShowFoods.subscribe((value) => {
		showFoods = value
	})

	$: if (showFoods && !isMobi) {
		let clHeight = document.querySelector('#foods_menu')
		if (clHeight) {
			const foodsTO = setTimeout(() => {
				clHeight = document.querySelector('#foods_menu').clientHeight
				offsetFood = document.querySelector('#foods_menu').getBoundingClientRect()
				if (offsetFood.top - 400 < -clHeight) {
					storeShowFoods.set(false)
					animateScroll.scrollTo({ element: '#foodstitle', duration: 500 })
				}

				// if (offsetFood.top > windowHeight + 200) {
				// 	storeShowFoods.set(false)
				// }
				clearTimeout(foodsTO)
			}, 200)
		}
	}

	const stoShowDrinks = storeShowDrinks.subscribe((value) => {
		showDrinks = value
	})

	$: if (showDrinks && !isMobi) {
		let clHeight = document.querySelector('#drinks_menu')
		if (clHeight) {
			const drinksTO = setTimeout(() => {
				clHeight = document.querySelector('#drinks_menu').clientHeight
				offsetDrinks = document.querySelector('#drinks_menu').getBoundingClientRect()
				if (offsetDrinks.top - 200 < -clHeight) {
					storeShowDrinks.set(false)
					animateScroll.scrollTo({ element: '#drinkstitle', duration: 500 })
				}

				// if (offsetDrinks.top > windowHeight + 300) {
				// 	storeShowDrinks.set(false)
				// }
				clearTimeout(drinksTO)
			}, 200)
		}
	}

	const stoShowBooking = storeShowBooking.subscribe((value) => {
		showBooking = value
	})

	$: if (showBooking) {
		const drinksTO = setTimeout(() => {
			const clHeight = document.querySelector('#booking').clientHeight
			offsetDrinks = document.querySelector('#booking').getBoundingClientRect()
			if (offsetBooking.top - 400 < -clHeight) {
				storeShowBooking.set(false)
				animateScroll.scrollTo({ element: '#bookingtitle', duration: 500 })
			}

			if (offsetDrinks.top > windowHeight + 200) {
				storeShowDrinks.set(false)
			}
			clearTimeout(drinksTO)
		}, 200)
	}

	const stoShowGallery = storeShowGallery.subscribe((value) => {
		showGallery = value
	})

	$: if (showGallery) {
		const galleryTO = setTimeout(() => {
			const clHeight = document.querySelector('#gallery_container').clientHeight
			offsetGallery = document.querySelector('#gallery_container').getBoundingClientRect()
			if (offsetGallery.top - 200 < -clHeight) {
				storeShowGallery.set(false)
				animateScroll.scrollTo({ element: '#gallery_blockTitle', duration: 500 })
			}
			if (offsetGallery.top > windowHeight + 200) {
				storeShowGallery.set(false)
			}

			clearTimeout(galleryTO)
		}, 200)
	}

	const stoContact = storeContact.subscribe((value) => {
		showForm = value
	})

	$: if (showForm) {
		const conatactTo = setTimeout(() => {
			const clContainer = document.querySelector('#contactContainer')
			if (clContainer) {
				const clHeight = document.querySelector('#contactContainer').clientHeight
				offsetContact = document.querySelector('#contactContainer').getBoundingClientRect()
				if (offsetContact.top - 200 < -clHeight) {
					storeContact.set(false)
					animateScroll.scrollTo({ element: '#contact_title', duration: 500 })
				}

				if (offsetContact.top > windowHeight + 200) {
					storeContact.set(false)
				}
			}
			clearTimeout(conatactTo)
		}, 200)
	}

	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	const show_gallery = () => {
		storeShowGallery.set(true)
	}

	const stoSiteManagement = storeSiteManagement.subscribe((value) => {
		siteManagement = value
	})

	onMount(() => {
		if ($storeActiveBlock) {
			let blockID = $storeActiveBlock.split(' ')
			blockID = '#' + blockID[0] + '_' + blockID[1]
			animateScroll.scrollTo({ element: blockID, duration: 500 })
		}

		document.querySelector('body').style.backgroundColor = bg
	})

	onDestroy(() => {
		stoData
		stoShowGallery
		stoShowTools
		stoPreview
		stoSiteManagement
		stoContact
		stoShowFoods
		stoShowDrinks
		stoShowRooms
		stoShowBooking
		storeShowTools.set(false)
	})
</script>

{#await configFile}
	<Shader>
		<div slot="content">
			<Spinner info="site loading" color={inputBgFocus} />
		</div>
	</Shader>
{:then config}
	<body style="background-color:{bg};">
		{#if !siteManagement}
			<main id="builderBlock">
				{#if !showPreview}
					<div
						class="content_row"
						use:styles={{ fsS, builderToolbar, builderToolbarHover }}
						on:click={() => set_elementID('Site')}
						on:keydown={() => set_elementID('Site')}
					>
						<div style="margin-left:20px;">*OPEN SITE TOOL*</div>
					</div>
				{/if}
				{#if !showGallery}
					<ScrollTop color={caretColor} colorHover={caretHover} />
				{/if}
				{#each config.blocks as block}
					{#if block.blockName === 'navbar'}
						<Navbar />
					{:else if block.blockName === 'contact'}
						<Contact />
					{:else if block.blockName === 'rooms'}
						<GuestHouse />
					{:else if block.blockName === 'drinks'}
						<Drinks />
					{:else if block.blockName === 'foods'}
						<Foods />
					{:else if block.blockName === 'booking'}
						<Booking />
					{:else if block.blockName === 'shop'}
						<Shop />
					{:else if block.blockName.indexOf('Block') > -1 && !block.singleImageBlock && !block.isLinked}
						<Block blockName={block.blockName} />
					{:else if block.blockName.indexOf('Block') > -1 && !block.singleImageBlock && block.isLinked && !showPreview}
						<Block blockName={block.blockName} linkedSite={true} />
					{:else if block.blockName.indexOf('Block') > -1 && block.singleImageBlock}
						<SingleImageBlock blockName={block.blockName} />
					{:else if block.blockName === 'gallery'}
						{#if block.content.length > 2 && (block.content.length - 1) % 2 === 0 && block.content.length < 21}
							<GalleryBlock on:opengallery={show_gallery} />
						{:else}
							<div class="column_title error" use:styles={{ colorError }}>ERROR: GALLERY HAS MISSING CONTENTS</div>
						{/if}

						{#if showGallery}
							<div transition:slide={{ duration: 500 }}>
								<Gallery on:closegallery={show_gallery} content={block.content} title={block.blockTitle} />
							</div>
						{/if}
					{:else if block.blockName === 'cover-slider'}
						{#if block.content.length > 2 && (block.content.length - 1) % 2 === 0 && block.content.length < 6}
							<Slider content={block.content} />
						{:else}
							<div class="column_title error" use:styles={{ colorError }}>ERROR: SLIDER HAS MISSING CONTENTS</div>
						{/if}
					{/if}
				{/each}
			</main>

			<CookieConsent />
		{:else}
			<Administrator />
		{/if}
	</body>
{/await}

<style>
	main {
		position: relative;
	}

	.column_title {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: flex-start;
		margin: 1%;
		font-style: italic;
		font-weight: bold;
	}

	.error {
		color: var(--colorError);
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
